export function Refresh() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect width="24" height="24" fill="none"/>
      <path d="M12 5.75c0 .414-.338.745-.748.8a5.501 5.501 0 106.198 6.198c.055-.41.386-.748.8-.748.414 0 .754.337.71.749a7.001 7.001 0 11-7.709-7.71c.412-.043.749.297.749.711z" fill="currentColor"></path><path fillRule="evenodd" clipRule="evenodd" d="M15.267 5.2a1 1 0 010 1.6l-2.667 2A1 1 0 0111 8V4a1 1 0 011.6-.8l2.667 2z" fill="currentColor"></path>
    </svg>
  );
}